import { shop } from '@/commonTypes';
import styles from './styles.module.css';
import AppLink from '@/components/common/AppLink';
import BlogCover from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard/BlogCover';
import RateComponent from '@/components/common/RateComponent';
import Button from '@/components/common/Button';
import ReserveButton from '@/components/pages/service/SingleServiceContent/ServiceCard/ReserveButton';
import MainIcons from '@/icons/main';
import ShopAddress from '../../SingleShopContent/ShopAddress';

const ShopCard = ({
  item,
  index = 0,
  showDetails = false,
}: {
  item?: shop;
  index?: number;
  showDetails?: boolean;
}) => {
  console.log('item==', item);
  return (
    <div className={styles.card} dir="rtl">
      <AppLink href={`/shops/${item?.slug}`} className={styles.cover}>
        <BlogCover item={item} index={index}>
          {item?.category && <span className={styles.category}>{item?.category?.title}</span>}

          <span className={styles.badge}>اصالت کالا</span>
        </BlogCover>
      </AppLink>

      <div className={styles.body}>
        <AppLink href={`/shops/${item?.slug}`} className={styles.title}>
          {item?.title}
        </AppLink>

        <div className={styles.meta}>
          <span className={styles.rating}>
            {/* ★ <span>۴.۹</span> */}
            <RateComponent
              number={1}
              className={`w-auto`}
              rate={Number(item?.rating)}
              activeFillColor="var(--accent-red)"
            />
            {item?.rating}
          </span>

          <span className={styles.location}>
            <MainIcons.locationIcon width="12px" height="12px" fill="currentColor" />
            <span>{item?.distance}</span>
          </span>

          <span className={styles.open}>باز است</span>
        </div>

        <div className={styles.products}>{item?.productCount} کالا در بازارچه</div>
        {showDetails && <ShopAddress shop={item} className={`${styles.addressContainer}`} />}
        <div className={styles.actions}>
          <AppLink href={`/shops/${item?.slug}`} className={styles.button}>
            مشاهدهٔ فروشگاه
          </AppLink>
          {item?.services && (
            <ReserveButton
              text={`رزرو`}
              item={item}
              className={`${styles.reserveButton}`}
              type="shop"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
